<template>
  <div class="carrot">

    <div class="main-wrapper">
      <Menu></Menu>
      <Preview :visible="is_preview" @close="vue_close" :preview_notice="preview_notice"
               :notice="notice"></Preview>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">공지사항/이벤트 수정</h3>
              <!-- <p class="lead">
                  - CARROT 앱에 로그인 성공한 회원만 표시됩니다.<br>
                  - 회원구분: CTM(전화영어 학습자), ITM(글로벌 오프라인 학습자), 통합 (전화영어 + 글로벌 오프라인 학습자)
              </p> -->
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center mt-20">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th><span class="red">*</span>&nbsp;구분</th>
                        <td class="txt-left">
                          <label><input type="radio" v-model="notice.subject" value="공지사항">공지사항</label>
                          <label class="ml-1"><input type="radio" v-model="notice.subject" value="이벤트">이벤트</label>
                          <!--<button @click="notice.subject = '공지사항'" class="btn w-30 btn-dark "
                                  :class="{ 'disabled' : notice.subject !== '공지사항'}"> 공지사항
                          </button>
                          <button @click="notice.subject = '이벤트'" class="btn w-30 btn-dark ml-1"
                                  :class="{ 'disabled' : notice.subject !== '이벤트'}"> 이벤트
                          </button>-->
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;제목</th>
                        <td class="txt-left">
                          <input v-model="notice.title" type="text" class="form-control w-100per"/>
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>&nbsp;사용여부</th>
                        <td class="txt-left">
                          <label><input type="radio" v-model="notice.isUse" value="Y">사용</label>
                          <label class="ml-1"><input type="radio" v-model="notice.isUse" value="N">사용안함</label>
                          <!--<button @click="notice.isUse = 'Y'" class="btn w-30 btn-dark "
                                  :class="{ 'disabled' : notice.isUse === 'N'}"> 사용
                          </button>
                          <button @click="notice.isUse = 'N'" class="btn w-30 btn-dark ml-1"
                                  :class="{ 'disabled' : notice.isUse === 'Y'}"> 사용안함
                          </button>-->
                        </td>
                      </tr>
                      <tr>
                        <th><span class="red">*</span>내용</th>
                        <td class="txt-left editor">
                          <ckeditor :editor="editor" v-model="notice.content"
                                    :config="editorConfig"></ckeditor>
                        </td>
                      </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="clear mt-20">
                    <button type="submit" class="btn btn-primary fl"
                            @click="$router.push('/notice')">목록
                    </button>
                    <button type="submit" class="btn btn-danger fl ml-10"
                            @click="deleteNotice(notice.idx)">삭제
                    </button>
                    <button type="submit" class="btn btn-primary fr ml-10"
                            @click="putNotice(notice.idx)">저장
                    </button>
                    <button type="submit" class="btn btn-primary fr" @click="showPreview()">미리보기
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import router from "@/router";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Menu from '../../components/inc_menu.vue'
import Preview from "../../components/preview/pop_preview_notice.vue";

export default {
  name: 'NoticeModfiy',
  components: {
    Menu,
    Preview
  },
  props: {
    msg: String
  },

  data: () => ({
    notice: {
      idx: 0,
      idxEmp: 0,
      readCount: 0,
      title: "",
      subject: "",
      isUse: "",
      file1: "",
      file2: "",
      file3: "",
      content: ""
    },
    is_preview: false,

    isLoading1: false,
    isLoading2: false,
    isLoading3: false,

    preview_notice: {},
    editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      // The configuration of the editor.
      filebrowserUploadUrl: 'https://stage-platform-api.carrotenglish.net/v1/admin/editor',
      // The configuration of the editor.
      ckfinder: {
        uploadUrl: 'https://stage-platform-api.carrotenglish.net/v1/admin/editor'
      }
    }
  }),

  mounted() {
    this.initPage();
  },

  methods: {
    showPreview: function () {
      this.preview_notice = this.notice;
      this.is_preview = true;
    },
    vue_close: function (state) {
      this.is_preview = state;
    },
    initPage: function () {
      var me = this;
      this.axios.get(this.$store.state.host + "/v1/admin/notices/" + this.$route.params.idx)
      .then((res) => {
        this.notice = res.data.result;
        me.editorData = this.notice.content;
      });
    },

    putNotice: function (idx) {
      const url = this.$store.state.host + "/v1/admin/notices/" + idx;
      if (this.notice.title === null || this.notice.title === '') {
        alert('제목을 입력해주세요.');
      } else if (this.notice.content === null || this.notice.content === '') {
        alert('내용을 입력해주세요.');
      } else {
        this.axios.put(url, this.notice)
        .then(function (res) {

          var data = res.data;

          if (data.status === 0) {
            alert("수정이 완료되었습니다.")
            router.push("/notice")
          } else {
            alert("수정에 실패했습니다." + data.result);
          }
        });
      }
    },

    deleteNotice: function (idx) {
      const url = this.$store.state.host + "/v1/admin/notices/" + idx;
      this.axios.delete(url)
      .then(function (res) {
        var data = res.data;
        if (data.status === 0) {
          alert("삭제가 완료되었습니다.")
          router.push("/notice")
        } else {
          alert("삭제에 실패했습니다." + data.result);
        }
      });
    },

    selectImage: function (type) {
      let formData = new FormData();
      const url = this.$store.state.host + "/v1/admin/notices/file";
      let fileRefs;
      if (type === "file1") {
        fileRefs = this.$refs.file1.files[0];
      } else if (type === "file2") {
        fileRefs = this.$refs.file2.files[0];
      } else if (type === "file3") {
        fileRefs = this.$refs.file3.files[0];
      }

      formData.append('file', fileRefs);

      this.axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then((res) => {
        if (type === "file1") {
          this.notice.file1 = res.data.result;
          this.isLoading1 = false;
        } else if (type === "file2") {
          this.notice.file2 = res.data.result;
          this.isLoading1 = false;
        } else if (type === "file3") {
          this.notice.file3 = res.data.result;
          this.isLoading1 = false;
        }
      });
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.editor img {
  width: 100% !important;
  height: 100% !important;
}
</style>
